import React, { useState, useEffect } from "react";
import LoadingPage from "../loading/LoadingPage";

const withSplashScreen = (WrappedComponent) => {
  return () => {

    const [loading, setLoading] = useState(true);

    useEffect(() => {
      setTimeout(() => setLoading(false), 3000);
    }, []);

    if (loading) return <LoadingPage />;

    return <WrappedComponent />;
  };
};

export default withSplashScreen;